import {Injectable} from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  code?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [
  {
    label: 'Firma Digital de Documentos',
    main: [{
      state: 'firma.digital',
        name: 'Modulo de Documentos',
        type: 'sub',
        icon: 'ti-layout-grid2-alt',
        code: 'menu.afiliacion',
      children: [
        {
          state: 'bandeja-entrada',
          name: 'Bandeja de Entrada',
          type: 'link',
          icon: 'ti-layout-sidebar-left',
          code: 'menu.administrar.afiliacion'
        }
      ]
    }
    ]
  }
];

@Injectable()

export class MenuItems {

  getAll(): Menu[] {
    return MENUITEMS;
  }
}
